$(document).ready(function(){

    let formContacto = document.querySelector("#formContacto")

    let botonEnviar = document.querySelector("#btnEnviar")
    if(formContacto != null){
        formContacto.addEventListener("submit", async (e) => {
            e.preventDefault()


            let formData = new FormData(formContacto)

            botonEnviar.disabled = true
            botonEnviar.textContent = "Enviando..."

            try {
                const response = await fetch('/contacto', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        // Indispensable para que Laravel identifique la petición como AJAX
                        'X-Requested-With': 'XMLHttpRequest',
                        // El token CSRF se saca del input que genera @csrf
                        'X-CSRF-TOKEN': formContacto.querySelector('[name="_token"]').value
                    }
                });
                botonEnviar.disabled = false
                botonEnviar.textContent = "Enviar"

                if (!response.ok) {
                    if (response.status === 422) {
                        const errores = await response.json();
                        console.error('Errores de validación:', errores.errors);
                        swal("Revisa los campos del formulario", "", "info")
                        return;
                    }
                    throw new Error(`Error en el servidor: ${response.status}`);
                }

                const data = await response.json();
                if(data.error != null){
                    swal(data.error, "", "info")
                }
                else{
                    formContacto.reset()
                    swal(data.mensaje, "", "success")
                }
            } catch (error) {
                botonEnviar.disabled = false
                botonEnviar.textContent = "Enviar"
                console.error('Hubo un problema con la petición:', error.message);
                swal("No se pudo conectar con el servidor", "", "info")
            }
        })
    }
});
